import { set } from 'cerebral/operators'
import { state } from 'cerebral/tags'

export default [
  set(state`app.hasAgreedOnTerms`, true),
  set(state`startPage.showTerms`, false)
]



// WEBPACK FOOTER //
// ./src/modules/Startpage/chains/onCloseTerms.js